<template>
  <div class="_modals">
    <b-modal
      id="modal-option"
      ref="modalEditOption"
      centered
      hide-footer
      :title="titleModal"
    >
      <div class="modal-body">
        <div class="d-flex justify-content-center m-4">
          <img width="27" src="@/assets/image/icon/error-red.svg" alt="icon" />
        </div>

        <p class="text-center text-muted">{{ title1 }}</p>
        <p class="text-center mt-4">{{ title2 }}</p>
      </div>
      <div class="d-flex justify-content-center w-100 pt-4 mb-4">
        <button
          @click="yesOption"
          class="button__bluecorporite mr-2 "
          style="border"
        >
          Yes
        </button>
        <button @click="noOption" class="button__redcorporite ml-2">No</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'OptionModal',
  data () {
    return {
      titleModal: '',
      title1: '',
      title2: '',
      formData: {},
      modeOption: '',
      addressId: '',
      currentPage: 1,
      perPage: 4
    }
  },
  created () {
    this.$eventHub.$on('dialog-modal-option', this.dialogOption)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-modal-option')
  },
  methods: {
    dialogOption ({ title, title1, title2, modeOption, data, id, currentPage }) {
      this.titleModal = title
      this.title1 = title1
      this.title2 = title2
      this.modeOption = modeOption
      this.formData = data
      this.$refs.modalEditOption.show()
      this.addressId = id
      this.currentPage = currentPage
    },

    noOption () {
      this.$refs.modalEditOption.hide()
    },
    async yesOption () {
      if (this.modeOption === 'deleteBillingAddress') {
        await this.$store.dispatch('address/REMOVE_ADDRESS', this.addressId)
        this.$eventHub.$emit('dialog-modal-confirm', {
          option: 'yes',
          message: 'Success delete billing address.'
        })
        this.$store.dispatch('address/FETCH_ALL_ADDRESS', {page: this.currentPage, perPage: this.perPage})
      } else if (this.modeOption === 'editSettingAddress') {
        await this.$store.dispatch(`address/EDIT_MY_ADDRESS`, {data: this.formData, id: this.addressId})
        this.$eventHub.$emit('dialog-modal-confirm', {
          option: 'yes',
          message: 'Success edit address.'
        })
        this.$store.dispatch('address/FETCH_ALL_ADDRESS', {page: this.currentPage, perPage: this.perPage})
      } else if (this.modeOption === 'addSettingAddress') {
        await this.$store.dispatch('address/ADD_MORE_ADDRESS', this.formData)
        this.$eventHub.$emit('dialog-modal-confirm', {
          option: 'yes',
          message: 'Success add address.'
        })
        this.$store.dispatch('address/FETCH_ALL_ADDRESS', {page: this.currentPage, perPage: this.perPage})
      }
      this.$refs.modalEditOption.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/OptionModal.vue